import styled from "styled-components";
import { theme } from "../../theme/toyotaTheme";

export const Wrapper = styled.div`
    margin-top: ${theme.space[2]}px;
    margin-bottom: ${theme.space[3]}px;
    font-size: 1.4rem;
    color: ${theme.colors.primaryRed};
    a {
        color: ${theme.colors.primaryRed};
    }
`;
